import { useState } from 'react';
import { ContactoService } from '../../services/ContactoService';
import './ContactForm.css';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const INITIAL_FORM = { nombre: '', email: '', mensaje: '' };

export default function ContactForm() {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validar = () => {
    if (!formData.nombre.trim()) return 'El nombre es requerido';
    if (!formData.email.trim()) return 'El email es requerido';
    if (!EMAIL_REGEX.test(formData.email)) return 'El email no tiene un formato válido';
    if (!formData.mensaje.trim()) return 'El mensaje es requerido';
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResultado(null);

    const errorValidacion = validar();
    if (errorValidacion) {
      setResultado({ tipo: 'error', texto: errorValidacion });
      return;
    }

    setEnviando(true);
    try {
      await ContactoService.enviarContacto(formData);
      setResultado({ tipo: 'success', texto: '¡Gracias! Tu consulta fue enviada correctamente.' });
      setFormData(INITIAL_FORM);
    } catch (error) {
      setResultado({
        tipo: 'error',
        texto: error.message || 'No pudimos enviar tu consulta. Intentá de nuevo en unos minutos.',
      });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit} noValidate>
      <div className="contact-form__field">
        <label htmlFor="contacto-nombre">Nombre</label>
        <input
          id="contacto-nombre"
          type="text"
          name="nombre"
          value={formData.nombre}
          onChange={handleChange}
          placeholder="Ingresa tu nombre"
          autoComplete="name"
          disabled={enviando}
        />
      </div>

      <div className="contact-form__field">
        <label htmlFor="contacto-email">Email</label>
        <input
          id="contacto-email"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="ejemplo@email.com"
          autoComplete="email"
          disabled={enviando}
        />
      </div>

      <div className="contact-form__field">
        <label htmlFor="contacto-mensaje">Mensaje</label>
        <textarea
          id="contacto-mensaje"
          name="mensaje"
          value={formData.mensaje}
          onChange={handleChange}
          placeholder="Escribí tu consulta aquí..."
          rows={5}
          disabled={enviando}
        />
      </div>

      {resultado && (
        <div
          className={`contact-form__result contact-form__result--${resultado.tipo}`}
          role="status"
          aria-live="polite"
        >
          {resultado.texto}
        </div>
      )}

      <button type="submit" className="contact-form__submit" disabled={enviando}>
        {enviando ? 'Enviando…' : 'Enviar'}
      </button>
    </form>
  );
}
